import {axios, API} from '@/api'
import enrollments from './enrollments';
import { AxiosError } from 'axios';

export default {
  async getStates() {
    try {
      const response = await axios.get(API.getStates(), { headers: enrollments.getAuthHeaders() })
      return response.data
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        console.error('Error fetching states:', error.response?.data || error.message);
      } else if (error instanceof Error) {
        console.error('Unexpected error:', error.message);
      } else {
        console.error('Unknown error occurred:', error);
      }
      throw error;
    }
  },

  async getStateByAbbreviation(state) {
    try {
      const response = await axios.get(API.getStateByAbbreviation(state), { headers: enrollments.getAuthHeaders() })
      return response.data
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        console.error('Error fetching state by abbreviation:', error.response?.data || error.message);
      } else if (error instanceof Error) {
        console.error('Unexpected error:', error.message);
      } else {
        console.error('Unknown error occurred:', error);
      }
      throw error;
    }
  }
}
